import { Menu } from "lucide-react"
// material
import { AppBar, Box, IconButton, Stack, Toolbar } from "@mui/material"
import { alpha, styled } from "@mui/material/styles"
// hooks
import useCollapseDrawer from "../../hooks/useCollapseDrawer"
//
import AccountPopover from "./AccountPopover"
import Searchbar from "./Searchbar"
// import LanguagePopover from './LanguagePopover'
// import NotificationsPopover from './NotificationsPopover'

import { MHidden } from "../../components/library/@material-extend"

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280
const COLLAPSE_WIDTH = 102

const APPBAR_MOBILE = 64
const APPBAR_DESKTOP = 0

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up("lg")]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`
  }
}))

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up("lg")]: {
    display: "none",
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5)
  }
}))

// ----------------------------------------------------------------------

type DashboardNavbarProps = {
  onOpenSidebar: () => void
}

export default function DashboardNavbar({ onOpenSidebar }: DashboardNavbarProps) {
  const { isCollapse } = useCollapseDrawer()

  return (
    <RootStyle
      sx={{
        ...(isCollapse && {
          width: { lg: `calc(100% - ${COLLAPSE_WIDTH}px)` }
        })
      }}
    >
      <ToolbarStyle>
        <MHidden width="lgUp">
          <IconButton
            onClick={onOpenSidebar}
            sx={{ mr: 1, color: "text.primary" }}
            aria-label="Open menu"
          >
            <Menu size={24} />
          </IconButton>
        </MHidden>

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          {/* <LanguagePopover />
          <NotificationsPopover /> */}
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
    </RootStyle>
  )
}
